import { SortOrder } from '../sort-order';

export class DeviceFilters {
  serialNumber?: string;
  description?: string;
  categoryNames?: string[];
  rangeDates?: number[];
  sortField?: string;
  sortOrder?: SortOrder;
  tenantUuids?: string[];
  organizationUuids?: string[];
  minLastValueDate?: number;
  decoderNames?: string[];
  uuids?: string[];
}
